import { apiFetch } from "./httpClient";


export async function addOrder(orderData) {
  const URL = `/orders`;

  const response = await apiFetch(URL, {
    method: "POST",
    body: JSON.stringify(orderData),
    
  });

  const data = await response.json();
  const resData = await data;

  if (!response.ok) {
    let errorMessage;
    if (data && data.error && data.error.message) {
      errorMessage = data.error.message;
    }
    throw new Error(errorMessage);
  }
  return resData;
}

export async function getUserOrderList(id) {
  const URL = `/orders/getuserorder/${id}`;
  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch orders.");
  }

  return data;
}

export async function getUserOrderdetails(id) {
  const URL = `/orderdetails/${id}`;
  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch order detail.");
  }

  return data;
}
export async function getOrderDeliveryMessages(id) {
  const URL = `/orderdeliverymessages/entityId/${id}/entityType/6`;
  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch order track.");
  }

  return data;
}
